:host {
  position: relative;
  font-family: var(--font-family-sans);
  font-weight: var(--font-rg);
}

:host > z-popover {
  z-index: 10;
}

:host > z-popover > .tooltip-content {
  white-space: nowrap;
}

:host > z-chip span {
  display: block;
  overflow: hidden;
  max-width: 250px;
  letter-spacing: 0.32px;
  line-height: 1.33;
  text-overflow: ellipsis;
  white-space: nowrap;
}
